module.exports = __webpack_public_path__ + "img/video@2x.a488eb5.jpg";